import LinkButton from '@atlaskit/button/link';
import Heading from '@atlaskit/heading/heading';
import Image from '@atlaskit/image';
import { Flex } from '@atlaskit/primitives/components/flex';
import { Text } from '@atlaskit/primitives/text';
import { xcss } from '@atlaskit/primitives/xcss';
import { token } from '@atlaskit/tokens';
import { useRovoDevWebAnalyticsClient } from '@dev-agents/analytics';
import { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import codeReviewTickImg from '../../assets/code-review-tick.svg';
import { WarningIcon } from '../../assets/warning';

import messages from './messages';

const SuccessMessage = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Image
				// @ts-expect-error 2322: Image is not typed correctly
				src={codeReviewTickImg}
				alt=""
			/>
			<Heading size="xxlarge">{formatMessage(messages.authenticationSuccessful)}</Heading>
			<Text as="p">{formatMessage(messages.allDoneDescription)}</Text>
			<Text as="p">{formatMessage(messages.resubmitPullRequestInstructions)}</Text>
		</>
	);
};

const ErrorMessage = ({ errorDescription }: { errorDescription: string | null }) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<WarningIcon color={token('color.icon.accent.orange')} />
			<Heading size="xxlarge">{formatMessage(messages.authenticationFailed)}</Heading>
			<Text as="p">{formatMessage(messages.authenticationErrorDescription)}</Text>
			{errorDescription && <Text as="p">{errorDescription}</Text>}
		</>
	);
};

export const GithubOauthRedirectPage = () => {
	const { formatMessage } = useIntl();
	const { fireScreenEvent } = useRovoDevWebAnalyticsClient();
	const hasFiredScreenEvent = useRef(false);

	const urlParams = new URLSearchParams(window.location.search);
	const hasErrorParam = urlParams.has('errorDescription');
	const errorDescription = urlParams.get('errorDescription');

	useEffect(() => {
		if (!hasFiredScreenEvent.current) {
			fireScreenEvent({
				name: 'githubOauthRedirectPage',
				attributes: {
					isSuccess: !hasErrorParam,
					errorDescription: errorDescription || '',
				},
			});
			hasFiredScreenEvent.current = true;
		}
	}, [hasErrorParam, errorDescription, fireScreenEvent]);

	return (
		<Flex
			direction="column"
			gap="space.200"
			justifyContent="center"
			alignItems="center"
			xcss={wrapperStyles}
		>
			{hasErrorParam ? <ErrorMessage errorDescription={errorDescription} /> : <SuccessMessage />}
			<LinkButton href="https://github.com" appearance="primary">
				{formatMessage(messages.backToGitHubButton)}
			</LinkButton>
		</Flex>
	);
};

const wrapperStyles = xcss({
	height: 'calc(100vh - 48px)',
});
